import useScreenDimensions from './useScreenDimensions.js';

const useComponentScale = () => {
  const screenDimensions = useScreenDimensions();
  return screenDimensions.height / 1000;
};

export default useComponentScale;
